import { AppBar, Toolbar, Typography } from "@material-ui/core"
import { Desktop, Mobile } from "common/MediaQueries"
import { trackSubmenuModelPageClicks } from "common/analytics"
import { useScrollWithSections } from "common/bit/scrollSection"
import { useState } from "react"
import ButtonBaseBlank from "reusable/ButtonBaseBlank"
import styled from "styled-components"
import {
  HEADER_ANIME_D,
  HEADER_ANIME_M,
  HomePageContainer,
  StyledRow,
  TypographyRtl,
} from "theme/shared"
import CarModelSideDrawer from "./CarModelSideDrawer"

const StyledAppBar = styled(AppBar)`
  justify-content: center;
  background-color: ${(p) => p.theme.colors.headerColor};
  top: 0px;
  border-top: 1px solid rgba(153, 153, 153, 1);

  ${(p) => p.theme.breakpoints.up("md")} {
    border-top: 3px solid rgba(153, 153, 153, 1);
  }
`
const StyledContainer = styled(HomePageContainer)`
  /* margin-top: 112px; */
  height: ${HEADER_ANIME_M}px;
  transition: height 0.33s linear;
  ${(p) => p.theme.breakpoints.up("md")} {
    height: ${HEADER_ANIME_D}px;
  }
`
const StyledToolbar = styled(Toolbar).attrs({ disableGutters: true })`
  height: 100%;
  width: 100%;
  justify-content: space-between;
  min-height: auto;
  align-items: center;
`
const StyledText = styled(Typography).attrs({ variant: "body1" })`
  color: ${(p) => p.theme.colors.borderGrey};
  text-transform: uppercase;
  font-weight: 300;
`
const StyledSvgArrow = styled.img<{ $rotateUp: boolean }>`
  transform: ${(p) => (p.$rotateUp ? "rotate(180deg)" : "rotate(0deg)")};
  display: inline-block;
  transform: 0.4s linear;
  width: 18px;
  height: 18px;
  margin-right: 4px;
`
const StyledLinkButton = styled(ButtonBaseBlank)<{ $selected?: boolean }>`
  display: flex;
  justify-content: center;
  cursor: pointer;
  p {
    color: ${(p) =>
      p.$selected ? p.theme.colors.white : p.theme.colors.darkGrey};
    font-weight: 300;
  }
`

type CarModelNavBarProps = {
  modelName?: string
  className?: string
}

const CarModelNavBar = ({ modelName, className }: CarModelNavBarProps) => {
  const { sections, selectedSectionItem } = useScrollWithSections()

  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return
      }
      setIsDrawerOpen(open)
    }
  return (
    <>
      <StyledAppBar component="div" className={className}>
        <StyledContainer>
          <StyledToolbar>
            <Desktop>
              <StyledRow $gap="80px">
                {sections.map((item, i) => (
                  <div key={i}>
                    <StyledLinkButton
                      onClick={() => {
                        item.onClick()
                        trackSubmenuModelPageClicks()
                      }}
                      $selected={item.selected}
                    >
                      <TypographyRtl variant="body1">
                        {item.title}
                      </TypographyRtl>
                    </StyledLinkButton>
                  </div>
                ))}
              </StyledRow>
            </Desktop>
            <Mobile>
              <ButtonBaseBlank
                onClick={toggleDrawer(!isDrawerOpen)}
                aria-label="פתיחת תפריט צד"
              >
                <StyledText>{selectedSectionItem?.title}</StyledText>
                <StyledSvgArrow
                  src={`/icons/fi_chevron-down_white.svg`}
                  alt="downArrow"
                  $rotateUp={isDrawerOpen}
                />
              </ButtonBaseBlank>
            </Mobile>
            {modelName && <StyledText>{modelName}</StyledText>}
          </StyledToolbar>
        </StyledContainer>
      </StyledAppBar>
      <Mobile>
        <CarModelSideDrawer isOpen={isDrawerOpen} toggleDrawer={toggleDrawer} />
      </Mobile>
    </>
  )
}

export default CarModelNavBar
